import nicheCategoriesHandler from "../../services/NicheCategories";

export default {
    async loadNicheCategories({commit, dispatch}, payload) {
        const {data} = await nicheCategoriesHandler.all(payload);

        commit('SET_NICHE_CATEGORIES', data);
    },
    async loadAllNicheCategories({commit, dispatch}, payload) {
        const {data} = await nicheCategoriesHandler.getAll(payload);

        commit('SET_NICHE_CATEGORIES', data);
    },
    async storeNicheCategory({commit, dispatch}, payload) {
        return nicheCategoriesHandler.store(payload);
    },
    async updateNicheCategory({commit, dispatch}, payload) {
        return nicheCategoriesHandler.update(payload);
    },
    async destroyNicheCategory({commit, dispatch}, payload) {
        return nicheCategoriesHandler.destroy(payload);
    },
    async categorySoftDeleteHandler({commit, dispatch}, payload) {
        return nicheCategoriesHandler.softDelete(payload);
    },
}
